<template>
  <div>
    <div class="row mt-4">

      <div class="col-md-12 col-12 form-field">

        <div class="pb-2">
          <div class="title mt-3 required-field">
            <span>{{ FORM_LABELS.COMPANY_AND_CODE_NAME }}</span>
          </div>
          <div class="my-2">
            <div class="item select-style">
              <model-list-select
                  :list="companyCodeAndNameList"
                  :optionValue="'value'"
                  :optionText="'text'"
                  name="invoiceSubmissionData.companyCode"
                  @input="setCompanyCodeAndText"
                  v-validate="'required'"
                  v-model="companyCodeAndName"
                  id="companyCodeAndNameList"
              />
              <show-errors :for-item="'invoiceSubmissionData.companyCode'" :formErrors="errors" :field-name="FORM_LABELS.COMPANY_AND_CODE_NAME" />
            </div>
          </div>
        </div>

        

        <div class="pt-2">
          <attach-invoice :data="invoiceSubmissionData" 
                          @onInvoiceUploaded="onInvoiceUploaded($event, currentFormName)"
                          @onInvoiceDeleted="onInvoiceDeleted($event, currentFormName)"
                          :max-file-size-in-mb="CONSTANTS.ATTACHMENTS_MAX_SIZE_IN_MB.INVOICE_PAYMENT_FORMS"
                          :viewAttachment="true"
                          :multipleSelectionAllowed="true"
                          :is-required="true"
                          :attachment-title="CONSTANTS.ATTACH_AN_INVOICE"
                          :validFileTypes="CONSTANTS.FILE_TYPES.extensionAsPdf.validFileTypes"
                          :check-for-file-support="true" />
          <div class="text-danger input-error-text" v-if="showHelpTextForGermany">
            For invoices in <b>XML</b> format, this form is not required. Kindly request the <b>supplier</b> to email the XML file to <a href="mailto:ap.e-invoice.germany@autodesk.com">ap.e-invoice.germany@autodesk.com</a>.
          </div>
          <div class="text-danger input-error-text" v-if="showAttachmentsError">
            Invoice attachment is required
          </div>
        </div>

        <div class="float-md-right mt-4 pr-0">
          <button class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3" @click="navigateToHome">Cancel</button>
          <button class="btn-container btn flat-btn primary-blue-btn ml-2 my-3" @click="validateInvoiceSubmissionAndSetCurrentTab('PreviewInvoiceSubmission')">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelListSelect } from "vue-search-select";
import { mapGetters } from "vuex"
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import AttachInvoice from "../AttachInvoice";


export default {
  name: "InvoiceSubmissionQuestionnaire",
  components: { ModelListSelect, AttachInvoice },
 
  mixins: [PaymentFormsMixin],
  data() {
    return {
      componentKey: 0,
      companyCodeAndName: '',
      showHelpTextForGermany: false,
    }
  },
  mounted() {
    if(!this.isFormDataLoaded) {
      this.resetInvoiceSubmissionData()
    } else {
      this.setCompanyCodeAndTextField()
    }
    // po number not applicable here
    this.setIsInvalidPoNumber(false)
  },
  computed: {
  ...mapGetters(['invoiceSubmissionData', 'isFormDataLoaded']),
  },
  methods: {
    setCompanyCodeAndText(index) {
      this.invoiceSubmissionData.companyCode = this.getTextValue(this.adminDataList.companyCodeOptions, index)
      this.invoiceSubmissionData.companyCodeText = this.getTextValue(this.adminDataList.companyCodeTextOptions, index)
      this.showHelpTextForGermany = this.invoiceSubmissionData.companyCode == 2060
    },
    setCompanyCodeAndTextField() {
      let companyCode = this.adminDataList.companyCodeOptions.find(company => company.text === this.invoiceSubmissionData.companyCode)
      this.companyCodeAndName = companyCode ? companyCode.value : ''
      this.showHelpTextForGermany = companyCode.text == "2060"
    },
    validateInvoiceSubmissionAndSetCurrentTab(tab) {
      this.showAttachmentsError = !this.formAttachmentsExist(this.currentFormName)

      window.scrollTo(0,0)
      this.$validator.validateAll().then((result) => {
        if(result && !this.showAttachmentsError) {
          this.$emit('setCurrentTab', tab)
        }
      })
    },
  },

}

</script>

<style scoped>
.preview-notification {
  margin-left: 0
}

.select-style >>> .ui.selection.dropdown .menu  {
  max-height: 150px;
}


.checkboxes-field label {
  display: block;
  padding-right: 10px;
  padding-left: 22px;
  text-indent: -22px;
}
.checkboxes-field input {
  vertical-align: middle;
}
.checkboxes-field label span {
  vertical-align: middle;
}

.currency-select {
  max-width: 70px;
}

@media (max-width: 768px) {
  .expense-type-responsive {
    height: 50px;
  }
}
</style>

<style scoped src="@/assets/stylesheets/vueSearchSelectOverrides.css">

</style>